export const agencyCodeProviders = [
  {
    provider: "Aviva",
    emailAddress: "hrutuja.patnekar@rosemountfs.co.uk",
  },
  // {
  //   provider: "Aviva",
  //   emailAddress: "hrutujapatnekar@gmail.com",
  // },
  // {
  //   provider: "British Friendly",
  //   emailAddress: "management.information.rosemount@gmail.com",
  // },
];

export const agencyCodeProvidersFP = [
  // {
  //   provider: "Scottish Widows",
  //   emailAddress: "hrutujapatnekar22@gmail.com",
  // },
  {
    provider: "7IM",
    emailAddress: "hrutuja.patnekar@rosemountfs.co.uk",
  },
];

// export const agencyCodeProviders = [
//   {
//     provider: "Aviva",
//     emailAddress: "acinfo@aviva.com",
//   },
//   {
//     provider: "British Friendly",
//     emailAddress: "sales@britishfriendly.com",
//   },
//   {
//     provider: "Cirencester Friendly",
//     emailAddress: "emily-kate.day@cirencester-friendly.co.uk",
//   },
//   {
//     provider: "Exeter",
//     emailAddress: "agency@the-exeter.com",
//   },
//   {
//     provider: "Guardian",
//     emailAddress: "advisers@guardian1821.co.uk",
//   },
//   {
//     provider: "Holloway Friendly",
//     emailAddress: "advisersupport@holloway.co.uk",
//   },
//   {
//     provider: "Holloway Friendly",
//     emailAddress: "max.sheppard@holloway.co.uk",
//   },
//   {
//     provider: "HSBC Life",
//     emailAddress: "lifebdmsupport@hsbc.co.uk",
//   },
//   {
//     provider: "Legal & General",
//     emailAddress: "agency.appointments@landg.com",
//   },
//   {
//     provider: "LV",
//     emailAddress: "lv.agency@lv.com",
//   },
//   {
//     provider: "MetLife",
//     emailAddress: "aagency@metlife.com",
//   },
//   {
//     provider: "National Friendly",
//     emailAddress: "info@nationalfriendly.co.uk",
//   },
//   {
//     provider: "Royal London",
//     emailAddress: "protectionagency@royallondon.com",
//   },
//   {
//     provider: "Scottish Widows",
//     emailAddress: "christopher.duffin@scottishwidows.co.uk",
//   },
//   {
//     provider: "Vitality",
//     emailAddress: "vitalitylife_commissions@vitality.co.uk",
//   },
//   {
//     provider: "Zurich",
//     emailAddress: "zurich.intermediary@comms.zurich.co.uk",
//   },
// ];

// export const agencyCodeProvidersFP = [
//   {
//     provider: "Scottish Widows",
//     emailAddress: "christopher.duffin@scottishwidows.co.uk",
//   },
//   {
//     provider: "7IM",
//     emailAddress: "adam.roels@7im.co.uk",
//   },
// ];

// {
//   provider: "Aegon",
//   emailAddress: "referrals@aegon.co.uk",
// },
